
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"140","height":"140","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M111.667 4.25H37.823c-8.628.004-15.622 6.997-15.625 15.625v6.75h-7.344a3.125 3.125 0 100 6.25h7.312v20.5h-7.312a3.124 3.124 0 100 6.25h7.312v20.5h-7.312a3.125 3.125 0 100 6.25h7.312v20.5h-7.312a3.124 3.124 0 100 6.25h7.312v6.75c.004 8.628 6.997 15.621 15.625 15.625h73.844c8.628-.004 15.623-6.997 15.625-15.625v-100c.012-8.622-6.971-15.62-15.593-15.625zm9.375 115.625c-.016 5.171-4.204 9.36-9.375 9.375H37.823a9.403 9.403 0 01-9.375-9.375v-6.75h7.312a3.125 3.125 0 100-6.25h-7.312v-20.5h7.312a3.124 3.124 0 100-6.25h-7.312v-20.5h7.312a3.125 3.125 0 100-6.25h-7.312v-20.5h7.312a3.125 3.125 0 100-6.25h-7.312v-6.75a9.403 9.403 0 019.375-9.375h73.844c5.171.015 9.359 4.204 9.375 9.375v100z","fill":"#4B62C1"}}),_c('path',{attrs:{"d":"M74.73 68.969c8.37 0 15.156-6.785 15.156-15.156 0-8.372-6.786-15.157-15.156-15.157-8.372 0-15.157 6.785-15.157 15.157.008 8.367 6.788 15.148 15.157 15.156zm0-24.094a8.907 8.907 0 010 17.813 8.907 8.907 0 01-8.907-8.907 8.922 8.922 0 018.907-8.906zM74.73 74c-13 0-23.189 10.531-23.189 24a3.134 3.134 0 003.125 3.125h40.126A3.134 3.134 0 0097.917 98c0-13.469-10.189-24-23.188-24zM58.04 94.875c1.345-8.531 8.064-14.625 16.689-14.625 8.623 0 15.374 6.094 16.687 14.625H58.041z","fill":"#4B62C1"}})])
          )
        }
      }
    